module.exports = __webpack_public_path__ + "images/haftpflicht.png?8071ccbe0650c005ba1059a1d881f496";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haftpflicht.png
// module id = HyTB
// module chunks = 0